/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AgentchatInputs */

const en_mk_mx_agentchat = /** @type {(inputs: Mk_Mx_AgentchatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent chat messages per month`)
};

const id_mk_mx_agentchat = /** @type {(inputs: Mk_Mx_AgentchatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan chat ke agen per bulan`)
};

/**
* | output |
* | --- |
* | "Agent chat messages per month" |
*
* @param {Mk_Mx_AgentchatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_agentchat = /** @type {((inputs?: Mk_Mx_AgentchatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AgentchatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_agentchat(inputs)
	return en_mk_mx_agentchat(inputs)
});